module.exports = __webpack_public_path__ + "static/media/1020371.6134ac33.png";